import { PrimaryButton } from "@rpforms/shared";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import { EmployeeSickDay } from "./EmployeeSickDay";

export const EmployeeSickDays = ({ employeeId }) => {
    const [showForm, setShowForm] = useState(false);
    const employee = useSelector<RootState, any>((state) =>
        state.employees.employees.find((e) => e.id === parseInt(employeeId, 10))
    );

    return (
        <div>
            <h2 style={{ marginTop: "60px" }}>Krankheitstage</h2>
            {(employee?.sick_days || []).map((sickDay) => (
                <EmployeeSickDay key={sickDay.id} employeeId={employeeId} sickDay={sickDay} />
            ))}
            {showForm && <EmployeeSickDay employeeId={employeeId} />}
            {!showForm && (
                <div style={{ marginTop: "40px" }}>
                    <PrimaryButton onClick={() => setShowForm(true)}>Neu hinzufügen</PrimaryButton>
                </div>
            )}
        </div>
    );
};

export default EmployeeSickDays;
